import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";

// Fixed cue that appears whenever there is more page below the fold.
export const ScrollCue = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let frame = 0;
    const measure = () => {
      frame = 0;
      const doc = document.documentElement;
      const remaining = doc.scrollHeight - (window.scrollY + window.innerHeight);
      setShow(remaining > 120);
    };
    const onScroll = () => {
      if (!frame) frame = requestAnimationFrame(measure);
    };
    measure();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    const settle = setTimeout(measure, 600);
    return () => {
      if (frame) cancelAnimationFrame(frame);
      clearTimeout(settle);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <button
      type="button"
      aria-label="Scroll down"
      data-testid="scroll-cue"
      onClick={() => window.scrollBy({ top: window.innerHeight * 0.85, behavior: "smooth" })}
      className={`fixed bottom-6 left-1/2 z-40 -translate-x-1/2 rounded-full border border-steel-brass/40 bg-steel-surface/80 p-2.5 text-steel-brass backdrop-blur-sm transition-opacity duration-500 hover:bg-steel-brass/15 ${
        show ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      <ChevronDown className="h-4 w-4 animate-bounce" />
      <span className="sr-only">More below</span>
    </button>
  );
};

export default ScrollCue;
